<template>
  <div>
    <v-tabs
      align-with-title
    >
      <v-tab
        :to="{ name: 'General Ledger - Investments'}"
      >
        Investment
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - InveReports' }"
      >
       Reports
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InvestmentUtils',
  components: {
  },
  created() {
  },
  computed: {
    ...mapState({
      isPrintScreen: (state) => state.isPrintScreen,
    }),
  },
  methods: {
  },
};
</script>
